import React from 'react';
import { Link } from 'react-router-dom';
import { SignUpFrom, SignUpInput, SignUpHandler, SignUpAccept } from './form';
import { getLocaleWordContent } from '@/utils/language.util';
import { connect } from 'react-redux';
import PopUp from '@/components/contents/home/PopUp';

function SignUpPresenter({
    user,
    selection,
    validation,
    show,
    path,
    message_success,
    onChangeInput,
    onValidateMsg,
    onHandleBlurId,
    onHandleBlur,
    onHandleBlur2,
    onSubmit,
}) {
    return (
        <>
            {show.show && <PopUp message={message_success} path={path} />}
            <div className="login_inner">
                <div className="login_logo">
                    <img src={require('@/resources/assets/images/logo.png')} alt="logo" />
                </div>
                <h2 className="tit_log">
                    <Link to="/">{getLocaleWordContent('회원가입')}</Link>
                </h2>
                <div className="sp30"></div>
            </div>
            <div className="bg_left">
                <div className="log_box">
                    <div className="inputbox">
                        <SignUpFrom
                            onSubmit={onSubmit}
                            inputArea={
                                <SignUpInput
                                    user={user}
                                    selection={selection}
                                    message={validation.message}
                                    onChangeInput={onChangeInput}
                                    onValidateMsg={onValidateMsg}
                                    onHandleBlurId={onHandleBlurId}
                                    onHandleBlur={onHandleBlur}
                                    onHandleBlur2={onHandleBlur2}
                                />
                            }
                            acceptArea={<SignUpAccept terms={validation.terms} onChangeInput={onChangeInput} />}
                            handleArea={<SignUpHandler />}
                        />
                    </div>
                    <div className="sp20"></div>
                    <p className="goto text-center">
                        <Link to="/">{getLocaleWordContent('로그인')} ?</Link>
                    </p>
                    <div className="sp40"></div>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        show: state.widget.getIn(['message', 'show']),
    }),
    null,
)(SignUpPresenter);
